@import 'styles/mixins';

.root {
  flex: 1 0 0;
  align-self: stretch;
  border: 3px solid var(--light-60);
  display: flex;
  flex-direction: column;
  min-width: 0;

  .content {
    min-width: 0;
    background-image: var(--image);
    background-size: cover;
    background-repeat: no-repeat;
    background-origin: content-box;
    flex: 1;
    border-radius: 2.5px;
  }

  &.isSelected {
    border: 10px solid var(--selected-stroke);
  }
}
